<template>
  <el-dialog
    title="修改密码"
    :visible="formVisible"
    width="30%"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <el-form
      :model="ruleForm"
      status-icon
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      :rules="rules"
    >
      <el-form-item label="旧密码" prop="oldPass">
        <span slot="label">
          旧密码
          <span style="color: red">*</span>
        </span>
        <el-input
          type="password"
          v-model="ruleForm.oldPass"
          autocomplete="off"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPass">
        <span slot="label">
          新密码
          <span style="color: red">*</span>
        </span>
        <el-input
          type="password"
          v-model="ruleForm.newPass"
          autocomplete="off"
          placeholder="8到20位，由字母，数字，特殊字符组成"
        ></el-input>
      </el-form-item>
      <el-form-item label prop="repeatPassword">
        <span slot="label">
          确认密码
          <span style="color: red">*</span>
        </span>
        <el-input
          type="password"
          v-model="ruleForm.repeatPassword"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelForm('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="saveForm('ruleForm')">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import MD5 from "js-md5";
// import router from "../../router/index"
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newPass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    // var validatePass1 = (rule, value, callback) => {
    //   let regStr = /^(?![a-zA-Z0-9]+$)(?![^a-zA-Z/D]+$)(?![^0-9/D]+$).{8,20}$/;
    //   if (!regStr.test(value)) {
    //     callback(
    //       new Error("密码必须是字母，数字，特殊字符组成，且长度为8到20位")
    //     );
    //   } else {
    //     callback();
    //   }
    // };

    return {
      ruleForm: this.ruleFormProps,
      rules: {
        oldPass: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newPass: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            message: "密码必须是字母，数字，特殊字符组成，且长度为8到20位",
            pattern:
              /^(?![a-zA-Z0-9]+$)(?![^a-zA-Z/D]+$)(?![^0-9/D]+$).{8,20}$/,
          },
        ],
        repeatPassword: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  props: {
    formVisible: Boolean,
    ruleFormProps: Object,
    addormodify: String,
    username: String,
  },
  methods: {
    cancelForm(ruleForm) {
      // 点击取消 数据重置
      this.$refs[ruleForm].resetFields();
      this.$emit("closeDialogForm");
    },
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = { ...this.ruleForm };
          param.userName = this.$store.state.login.userInfo.username;
          delete param["repeatPassword"];
          param.oldPass = MD5(param.oldPass);
          param.newPass = MD5(param.newPass);
          this.$store.dispatch("modifyPass", {
            param,
            cb: (data) => {
              if (data.code !== "0000") {
                this.$notify({
                  title: "error",
                  message: "修改失败",
                  type: "error",
                });
              } else {
                this.$router.push("/login");
                this.$emit("closeDialogForm");
              }
            },
          });
        } else {
          return false;
        }
      });
    },
  },
  watch: {
    ruleFormProps: function (val) {
      this.ruleForm = val;
    },
  },
};
</script>